import styled from 'styled-components';
export const Control = styled.div `
  margin-left: 12px;
  color: var(--color-base-gray6);
  display: flex;
  align-items: center;
  &:hover {
    cursor: pointer;
    color: var(--color-base-white);
  }

  &.active {
    color: var(--color-base-white);
  }
`;
export const IconContainer = styled.div `
  display: flex;
  align-items: center;

  svg {
    width: 24px;
    height: 24px;
  }
`;
